import React from "react"

import FieldProto from "../../field-proto"
import {ConditionType, IConditionType} from "../../../../model2/conditions/condition-types"
import FieldDropdown from "../../../generic/dropdown/dropdown";
import {FIELDS} from "../../../fields.const";
import FieldFormElementView from "../../../render/form-elemnent-view";
import {PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const";

type Props = {
    field   : FieldProto,
    value?  : ConditionType,

    // onChange: {(option: Option, onCancelChange: {():void}):void}    // callback (option, onCancelChange):void
    onChange: onChangeCallback
}

export default function ConditionTypeSelector(props: Props) {


    // we support group by headers here... used in date selector

    const conditionOptionsGroups = _(props.field.conditionTypes)
        .groupBy((conditionType:typeof IConditionType)=>{
            return conditionType.groupHeader
        })
        .toPairs()
        .map(arrRec=>({
            groupHeader     : arrRec[0]!=='undefined'?arrRec[0]:null,
            conditionTypes  : arrRec[1]
        }))
        .value()

    const conditionOptions:Option[] = []

    _.map(conditionOptionsGroups,(group:any) => {
            if (group.groupHeader) {
                conditionOptions.push({
                    type: PopoverMenuItemType.HEADER,
                    title: group.groupHeader
                })
            }
            _.map(group.conditionTypes, (conditionType)=>{
                conditionOptions.push(conditionType.toOption())
            })
        }
    )

    const field = new FieldDropdown({
        fieldId         : 'conditionTypeSelector',
        type            : FIELDS.DROPDOWN,
        options         : conditionOptions,
        noValueOption   : false,
        showMenuMore    : false,
    })

    return <FieldFormElementView field={field}
                                 model={{conditionTypeSelector: props.value}}
                                 onChange={props.onChange}
                                 className="selector w-140"
            />
}